module.exports = __webpack_public_path__ + "img/vnm.418297b0.svg";